import { useEffect, useState } from "react"
import dayjs from 'dayjs'

const Table1 = ({ data, project }) => {
    const [firstPrev, setFirstPrev] = useState()
    const [lastPrev, setLastPrev] = useState()
    const [isSingleApartment, setIsSingleApartment] = useState(false)

    useEffect(() => {
        setFirstPrev(data.firstPreview)
        setLastPrev(data.lastPreview)
        setIsSingleApartment(data.tables.length === 1 && data.tables[0].rows.length === 1)
    }, [data])

    return (
        <div className='py-5 px-2'>
            <div className='row d-flex justify-content-between'>
                {isSingleApartment ? (
                    <div className="col-lg-6 mx-auto">
                        <h5 className='text-center w-100'>"{project.project_name}" seçilən mənzil mənzil</h5>
                        <table className='table table-bordered'>
                            {data && (firstPrev || lastPrev) &&
                                <tbody>
                                    {(() => {
                                        const prev = firstPrev || lastPrev
                                        return (
                                            <>
                                                <tr>
                                                    <td>Bina №</td>
                                                    <td>{prev.buildingNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Giriş №</td>
                                                    <td>{prev.entranceNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Mərtəbə №</td>
                                                    <td>{prev.floorNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Mənzil №</td>
                                                    <td>{prev.apartmentNumber}</td>
                                                </tr>
                                                <tr>
                                                    <td>Otaq sayı</td>
                                                    <td>{prev.roomsCount}</td>
                                                </tr>
                                                <tr>
                                                    <td>Mənzilə baxış keçirilməsinin başlama vaxtı</td>
                                                    <td>{dayjs(prev.previewOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                                </tr>
                                                <tr>
                                                    <td>Mənzil seçminin təsdiqləmə vaxtı</td>
                                                    <td>{dayjs(prev.confirmOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                                </tr>
                                                <tr>
                                                    <td>Mənzil seçimi ərizəsinin imzalanma vaxtı</td>
                                                    <td>{dayjs(prev.signatureOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                                </tr>
                                                {(project?.first_preview_note || project?.last_preview_note) != null &&
                                                (project.first_preview_note || project.last_preview_note) !== '' &&
                                                <tr>
                                                    <td>Qeyd</td>
                                                    <td>{project.first_preview_note || project.last_preview_note}</td>
                                                </tr>
                                                }
                                            </>
                                        )
                                    })()}
                                </tbody>
                            }
                        </table>
                    </div>
                ) : (
                    <>
                        <div className="col-lg-6">
                            <h5 className='text-center w-100'>"{project.project_name}" üçün baxış keçirilən ilk mənzil</h5>
                            <table className='table table-bordered'>
                                {data && firstPrev &&
                                    <tbody>
                                        <tr>
                                            <td>Bina №</td>
                                            <td>{firstPrev.buildingNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Giriş №</td>
                                            <td>{firstPrev.entranceNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Mərtəbə №</td>
                                            <td>{firstPrev.floorNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzil №</td>
                                            <td>{firstPrev.apartmentNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Otaq sayı</td>
                                            <td>{firstPrev.roomsCount}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzilə baxış keçirilməsinin başlama vaxtı</td>
                                            <td>{dayjs(firstPrev.previewOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzil seçminin təsdiqləmə vaxtı</td>
                                            <td>{dayjs(firstPrev.confirmOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzil seçimi ərizəsinin imzalanma vaxtı</td>
                                            <td>{dayjs(firstPrev.signatureOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                        {project?.first_preview_note != null && project.first_preview_note !== '' &&
                                        <tr>
                                            <td>Qeyd</td>
                                            <td>{project.first_preview_note}</td>
                                        </tr>
                                        }
                                    </tbody>
                                }
                            </table>
                        </div>
                        <div className="col-lg-6">
                            <h5 className='text-center w-100'>"{project.project_name}" üçün baxış keçirilən son mənzil</h5>
                            <table className='table table-bordered'>
                                {data && lastPrev &&
                                    <tbody>
                                        <tr>
                                            <td>Bina №</td>
                                            <td>{lastPrev.buildingNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Giriş №</td>
                                            <td>{lastPrev.entranceNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Mərtəbə №</td>
                                            <td>{lastPrev.floorNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzil №</td>
                                            <td>{lastPrev.apartmentNumber}</td>
                                        </tr>
                                        <tr>
                                            <td>Otaq sayı</td>
                                            <td>{lastPrev.roomsCount}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzilə baxış keçirilməsinin başlama vaxtı</td>
                                            <td>{dayjs(lastPrev.previewOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzil seçminin təsdiqləmə vaxtı</td>
                                            <td>{dayjs(lastPrev.confirmOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                        <tr>
                                            <td>Mənzil seçimi ərizəsinin imzalanma vaxtı</td>
                                            <td>{dayjs(lastPrev.signatureOn).format('YYYY-MM-DD HH:mm:ss')}</td>
                                        </tr>
                                        {project?.last_preview_note != null && project.last_preview_note !== '' &&
                                        <tr>
                                            <td>Qeyd</td>
                                            <td>{project.last_preview_note}</td>
                                        </tr>
                                        }
                                    </tbody>
                                }
                            </table>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default Table1
